module.exports = __webpack_public_path__ + "img/precious_golem_factory_small.bb858526.png";